import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, NgModule, Optional } from '@angular/core';
import * as i1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i2 from '@angular/platform-browser';
import * as i1$1 from '@angular/common/http';

class XpoIconSmall {
}
XpoIconSmall.ɵfac = function XpoIconSmall_Factory(t) { return new (t || XpoIconSmall)(); };
XpoIconSmall.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoIconSmall, selectors: [["", "xpoIconSmall", ""]], hostAttrs: [1, "xpo-Icon--small"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoIconSmall, [{
        type: Directive,
        args: [{
                selector: '[xpoIconSmall]',
                host: { class: 'xpo-Icon--small' },
            }]
    }], null, null); })();

class XpoIcon {
    constructor(matIconRegistry, domSanitizer) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
    }
    set iconName(value) {
        this.iconNameValue = value;
        if (XpoIcon.registeredIcons.indexOf(value) === -1) {
            this.matIconRegistry.addSvgIcon(value, this.domSanitizer.bypassSecurityTrustResourceUrl(`./assets/xpo-icons/${value}.svg`));
            XpoIcon.registeredIcons.push(value);
        }
    }
    get iconName() {
        return this.iconNameValue;
    }
}
XpoIcon.registeredIcons = [];
XpoIcon.ɵfac = function XpoIcon_Factory(t) { return new (t || XpoIcon)(i0.ɵɵdirectiveInject(i1.MatIconRegistry), i0.ɵɵdirectiveInject(i2.DomSanitizer)); };
XpoIcon.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoIcon, selectors: [["xpo-icon"]], hostAttrs: [1, "xpo-Icon"], inputs: { iconName: "iconName" }, decls: 1, vars: 1, consts: [[3, "svgIcon"]], template: function XpoIcon_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "mat-icon", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("svgIcon", ctx.iconName);
    } }, directives: [i1.MatIcon], styles: [".flex--stretch{flex:1}.xpo-Icon{display:inline-flex;height:20px;width:20px}.xpo-Icon .mat-icon{height:inherit;width:inherit}.xpo-Icon--small{height:18px;width:18px}.xpo-Icon--large{height:24px;width:24px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoIcon, [{
        type: Component,
        args: [{
                selector: 'xpo-icon',
                templateUrl: 'icon.component.html',
                styleUrls: ['icon.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-Icon' },
            }]
    }], function () { return [{ type: i1.MatIconRegistry }, { type: i2.DomSanitizer }]; }, { iconName: [{
            type: Input
        }] }); })();

class XpoIconLarge {
}
XpoIconLarge.ɵfac = function XpoIconLarge_Factory(t) { return new (t || XpoIconLarge)(); };
XpoIconLarge.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoIconLarge, selectors: [["", "xpoIconLarge", ""]], hostAttrs: [1, "xpo-Icon--large"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoIconLarge, [{
        type: Directive,
        args: [{
                selector: '[xpoIconLarge]',
                host: { class: 'xpo-Icon--large' }
            }]
    }], null, null); })();

class XpoIconModule {
    constructor(http) {
        if (!http) {
            console.error('XpoIconModule requires an import for HttpClientModule\n' +
                'You need to import the HttpClientModule in your AppModule!');
        }
    }
}
XpoIconModule.ɵfac = function XpoIconModule_Factory(t) { return new (t || XpoIconModule)(i0.ɵɵinject(i1$1.HttpClient, 8)); };
XpoIconModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoIconModule });
XpoIconModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatIconModule], MatIconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoIconModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, MatIconModule],
                declarations: [XpoIcon, XpoIconSmall, XpoIconLarge],
                exports: [XpoIcon, XpoIconSmall, XpoIconLarge, MatIconModule],
            }]
    }], function () { return [{ type: i1$1.HttpClient, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoIconModule, { declarations: [XpoIcon, XpoIconSmall, XpoIconLarge], imports: [CommonModule, MatIconModule], exports: [XpoIcon, XpoIconSmall, XpoIconLarge, MatIconModule] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoIcon, XpoIconLarge, XpoIconModule, XpoIconSmall };
